export const Q_LANGUAGE_APP_KEY = 'q-language';
export const Q_LANGUAGE_PRODUCT_ID = 'q_language_plus';

export type QLanguagePlanDefinition = {
  productPlanCode: 'Q_LANGUAGE_PLUS' | 'Q_LANGUAGE_PLUS_ANNUAL';
  basePlanId: 'monthly' | 'annual';
  billingCycle: 'MONTHLY' | 'ANNUAL';
  label: string;
};

export const Q_LANGUAGE_PLAN_DEFINITIONS: readonly QLanguagePlanDefinition[] = [
  {
    productPlanCode: 'Q_LANGUAGE_PLUS',
    basePlanId: 'monthly',
    billingCycle: 'MONTHLY',
    label: 'Q Language Plus 월간',
  },
  {
    productPlanCode: 'Q_LANGUAGE_PLUS_ANNUAL',
    basePlanId: 'annual',
    billingCycle: 'ANNUAL',
    label: 'Q Language Plus 연간',
  },
] as const;

export const findQLanguagePlanDefinition = (
  basePlanId: string,
): QLanguagePlanDefinition | null => {
  return Q_LANGUAGE_PLAN_DEFINITIONS.find(
    (plan) => plan.basePlanId === basePlanId,
  ) ?? null;
};

export const findQLanguagePlanDefinitionByPlanCode = (
  productPlanCode: string,
): QLanguagePlanDefinition | null => {
  return Q_LANGUAGE_PLAN_DEFINITIONS.find(
    (plan) => plan.productPlanCode === productPlanCode,
  ) ?? null;
};

export type QLanguageEntitlementAccess = 'AVAILABLE' | 'UNAVAILABLE' | 'UNKNOWN';

export const resolveQLanguageEntitlementAccess = (status: string): QLanguageEntitlementAccess => {
  switch (status.trim().toUpperCase()) {
    case 'ACTIVE':
    case 'IN_GRACE_PERIOD':
    case 'GRACE_PERIOD':
    case 'CANCELED_UNTIL_EXPIRY':
      return 'AVAILABLE';
    case 'ON_HOLD':
    case 'PAUSED':
    case 'EXPIRED':
    case 'REVOKED':
    case 'FREE':
      return 'UNAVAILABLE';
    default:
      return 'UNKNOWN';
  }
};
